import { render, staticRenderFns } from "./NilaiKelulusanForm.vue?vue&type=template&id=77f32408"
import script from "./NilaiKelulusanForm.vue?vue&type=script&lang=js"
export * from "./NilaiKelulusanForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports